import { Text, View, StyleSheet } from '@react-pdf/renderer';
import React from 'react';
const styles = StyleSheet.create({
  title: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '14px',
    color: '#2c3e50',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '0.8cm',
    paddingBottom: '0.3cm',
    borderBottom: '2px solid #548235',
  },
  content: {
    fontSize: '11px',
    color: '#34495e',
    lineHeight: 1.5,
    textAlign: 'justify',
    marginBottom: '0.5cm',
  },
  note: {
    fontSize: '11px',
    color: '#548235',
    fontFamily: 'Helvetica-Bold',
    lineHeight: 1.5,
    marginBottom: '0.5cm',
    padding: '0.3cm',
    backgroundColor: '#f8f9fa',
    borderRadius: '0.2cm',
    border: '1px solid #e8e8e8',
  },
  conditionItem: {
    fontSize: '11px',
    color: '#34495e',
    lineHeight: 1.5,
    marginBottom: '0.4cm',
    paddingLeft: '0.5cm',
    borderLeft: '3px solid #548235',
  },
  warning: {
    fontSize: '10px',
    color: '#e74c3c',
    fontFamily: 'Helvetica-Bold',
    lineHeight: 1.4,
    textAlign: 'justify',
    marginTop: '0.5cm',
    padding: '0.4cm',
    backgroundColor: '#fdf2f2',
    borderRadius: '0.2cm',
    border: '1px solid #fecaca',
  },
});

function BudgetConditions(props) {
  const { conditions, finishTime, include } = props;
  return (
    <View>
      <Text style={styles.title}>4. Condiciones</Text>

      {/* Nota sobre inclusión */}
      <Text style={styles.note}>Nota: Los valores de cada ítem incluyen {include}.</Text>

      {/* Condiciones de pago */}
      <Text style={styles.conditionItem}>
        <Text style={{ fontFamily: 'Helvetica-Bold' }}>Condiciones de pago:</Text> {conditions}
      </Text>

      {/* Tiempo de producción */}
      <Text style={styles.conditionItem}>
        <Text style={{ fontFamily: 'Helvetica-Bold' }}>Tiempo de producción:</Text> {finishTime}
      </Text>

      {/* Condiciones generales */}
      <Text style={styles.content}>
        <Text style={{ fontFamily: 'Helvetica-Bold' }}>Condiciones generales:</Text> El presupuesto
        tiene validez de 10 días corridos.
      </Text>

      {/* Advertencia importante */}
      <Text style={styles.warning}>
        LUEGO DE ESTE PLAZO, LA EMPRESA SE RESERVA EL DERECHO A MODIFICAR VALORES Y TIEMPOS DE
        EJECUCIÓN.
      </Text>
    </View>
  );
}

export default BudgetConditions;
